import {render} from 'react-dom'
import Menu from "./menu/Menu";

const menus = document.querySelectorAll('#MenuRoot');
if (menus.length > 0) {
  menus.forEach((menu) => {
    render(<Menu />, menu as HTMLElement)
  });
}
